import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth, database } from "./firebaseConfig";
import { doc, setDoc,getDoc, collection, addDoc, query, where, getDocs, onSnapshot, updateDoc, deleteDoc } from "firebase/firestore";

// دالة عامة للتعامل مع عمليات التسجيل وتسجيل الدخول

export const registerUser = async (username, email, password) => {
  if (!username || !email || !password) {
    return { success: false, error: "All fields are required." };
  }

  try {
    // Step 1: Create the user in Firebase Authentication
    const res = await createUserWithEmailAndPassword(auth, email, password);
    const user = res.user;

    // Step 2: Add the user data to Firestore
    const userDocRef = doc(database, "users", user.uid); // Reference to the user document
    await setDoc(userDocRef, {
      username: username,
      email: email,
      isAdmin: false, // Default role
      createdAt: new Date(),
    });

    return { success: true, user };
  } catch (error) {
    return { success: false, error:  error.message };
  }
};

// Function for user login
export const loginUser = async (email, password) => {
  if (!email || !password) {
    return { success: false, error: "Email and password are required." };
  }

  try {
    // Log in the user using Firebase Authentication
    const res = await signInWithEmailAndPassword(auth, email, password);
    const user = res.user;

    // Check if the user's document exists in Firestore
    const userDocRef = doc(database, "users", user.uid);
    const userDoc = await getDoc(userDocRef);

    if (!userDoc.exists()) {
      // If the document doesn't exist, create it
      await setDoc(userDocRef, {
        email: user.email,
        username: user.displayName || "Unknown User", // Default username
        createdAt: new Date(),
      });
    }

    return { success: true, user };
  } catch (error) {
    return { success: false, error:  error.message };
  }
};

// Function for user sign-out
export const signOutUser = async () => {
  try {
    // Sign out the user using Firebase Authentication
    await signOut(auth);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};


// دالة لإضافة كويز إلى مجموعة quizzes
export const addQuizForm = async (userId, quizData) => {
  if (!userId || !quizData) {
    return { success: false, error: "Invalid data." };
  }

  try {
    // إضافة كويز جديد إلى Firestore
    const quizzesRef = collection(database, "quizzes");
    const docRef = await addDoc(quizzesRef, {
      userId: userId,
      ...quizData,
      createdAt: new Date(),
    });

    return { success: true, id: docRef.id };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// دالة لاسترجاع الكويزات الخاصة بالمستخدم
export const getUserQuizzes = async (userId) => {
  if (!userId) {
    return { success: false, error: "User ID is required." };
  }

  try {
    // استرجاع الكويزات الخاصة بالمستخدم من Firestore
    const quizzesRef = collection(database, "quizzes");
    const q = query(quizzesRef, where("userId", "==", userId));
    const querySnapshot = await getDocs(q);

    const quizzes = [];
    querySnapshot.forEach((doc) => {
      quizzes.push({ id: doc.id, ...doc.data() }); // إضافة الكويز إلى المصفوفة
    });

    return { success: true, quizzes };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// دالة لاسترجاع كويز معين بناءً على  مع تحديثات مباشرة
export const getDataSubmit = async (quizId) => {
  try {
    if (!quizId) {
      console.error("Quiz ID is missing");
      throw new Error("Quiz ID is required");
    }

    console.log("Fetching quiz with ID:", quizId);
    
    // First try to fetch by Firebase ID
    const quizRef = doc(database, "quizzes", quizId);
    const quizDoc = await getDoc(quizRef);
    
    if (quizDoc.exists()) {
      console.log("Quiz found with Firebase ID");
      const quizData = quizDoc.data();
      return {
        quiz: { id: quizDoc.id, ...quizData },
        timeLimit: quizData.questions?.[0]?.timeLimit || 30,
        title: quizData.title || "Untitled Quiz",
        description: quizData.description || "",
        id: quizDoc.id,
      };
    }

    // If not found by Firebase ID, try to find by custom ID
    console.log("Quiz not found with Firebase ID, searching by custom ID");
    const collectionRef = collection(database, "quizzes");
    const querySnapshot = await getDocs(collectionRef);
    
    let foundQuiz = null;
    let foundDoc = null;
    
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      if (data.id === quizId) {
        foundQuiz = data;
        foundDoc = doc;
      }
    });

    if (foundQuiz && foundDoc) {
      console.log("Quiz found with custom ID");
      return {
        quiz: { id: foundDoc.id, ...foundQuiz },
        timeLimit: foundQuiz.questions?.[0]?.timeLimit || 30,
        title: foundQuiz.title || "Untitled Quiz",
        description: foundQuiz.description || "",
        id: foundDoc.id,
      };
    }

    // If still not found, show available IDs
    console.error("Quiz not found with ID:", quizId);
    const availableIds = querySnapshot.docs.map(doc => doc.id);
    console.log("Available quiz IDs:", availableIds);
    
    throw new Error("Quiz not found");
  } catch (err) {
    console.error("Error in getDataSubmit:", err);
    if (err.message === "Quiz not found") {
      throw new Error("Quiz not found. Please check the quiz ID.");
    } else if (err.message === "Invalid quiz data structure") {
      throw new Error("Quiz data is invalid. Please contact support.");
    } else if (err.message === "Quiz data is missing") {
      throw new Error("Quiz data is missing. Please try again later.");
    } else {
      throw new Error("Failed to fetch quiz data. Please try again later.");
    }
  }
};




export const getQuizsAll = async () => {
  try {
    const quizCollectionRef = collection(database, "quizzes");
    const querySnapshot = await getDocs(quizCollectionRef);
    
    if (querySnapshot.empty) {
      return { allQuiz: [] };
    }

    const allQuiz = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    return { allQuiz };
  } catch (error) {
    console.error("Error in getQuizsAll:", error);
    throw new Error("Failed to fetch quizzes");
  }
};






// دالة لتحويل أكواد الخطأ إلى رسائل خطأ مفهومة
export const getFrontendErrorMessage = (errorCode) => {
  switch (errorCode) {
    case "Firebase: Error (auth/user-not-found).":
      return "This email is not registered, please make sure you enter a registered email.";
    case "Firebase: Error (auth/wrong-password).":
      return "The password entered is wrong. Please make sure you enter the correct password.";
    case "Firebase: Password should be at least 6 characters (auth/weak-password).":
      return "The password should be at least 6 characters.";
    case "Firebase: Error (auth/email-already-in-use).":
      return "The email address is already in use. Please use a different email.";
    case "Firebase: Error (auth/invalid-email).":
      return "Invalid email address. Please enter a valid email.";
    case "Firebase: Error (auth/weak-password).":
      return "Weak password. Please choose a stronger password.";
    case "Firebase: Error (auth/invalid-login-credentials).":
      return "Incorrect credentials, please make sure you add correct ones.";
    case "Firebase: Error (auth/operation-not-allowed).":
      return "This operation is currently not allowed. Please try again later.";
    case "Firebase: Error (auth/too-many-requests).":
      return "Too many requests, please try again in some minutes";
    case "Firebase: Error (auth/app-not-authorized).":
      return "The app is not authorized to use Firebase Authentication.";
    case "Firebase: Error (auth/network-request-failed).":
      return "Network error. Please check your internet connection and try again.";
    case "Firebase: Error (auth/requires-recent-login).":
      return "Please log in again to continue.";
    case "Firebase: Error (auth/invalid-api-key).":
      return "Invalid API key. Please contact support.";
    default:
      return "An error occurred. Please try again.";}
};

export const addTabToDatabase = async (tabName) => {
  try {
    const tabsRef = collection(database, "tabs"); // تأكد من أن "tabs" هو اسم المجموعة الصحيح
    await addDoc(tabsRef, { name: tabName }); // تأكد من أن الحقل `name` موجود
    return true;
  } catch (error) {
    throw new Error("Failed to add tab to database");
  }
};
export const fetchQuizzesFromDatabase = async () => {
  try {
    const quizzesRef = collection(database, "quizzes"); // تأكد من أن "quizzes" هو اسم المجموعة الصحيح
    const querySnapshot = await getDocs(quizzesRef);

    if (querySnapshot.empty) {
      return []; // إرجاع مصفوفة فارغة إذا لم توجد كويزات
    }

    const quizzes = [];
    querySnapshot.forEach((doc) => {
      quizzes.push({ id: doc.id, ...doc.data() }); // إضافة الـ id إلى البيانات
    });

    return quizzes;
  } catch (error) {
    throw new Error("Failed to fetch quizzes from database");
  }
};
export const fetchTabsFromDatabase = async () => {
  try {
    const tabsRef = collection(database, "tabs"); // تأكد من أن "tabs" هو اسم المجموعة الصحيح
    const querySnapshot = await getDocs(tabsRef);

    if (querySnapshot.empty) {
      return []; // إرجاع مصفوفة فارغة إذا لم توجد خانات
    }

    const tabs = [];
    querySnapshot.forEach((doc) => {
      tabs.push(doc.data().name); // تأكد من أن الحقل `name` موجود في المستندات
    });

    return tabs;
  } catch (error) {
    throw new Error("Failed to fetch tabs from database");
  }
};

// دالة لجلب جميع المستخدمين
export const getAllUsers = async () => {
  try {
    const usersSnapshot = await getDocs(collection(database, "users"));
    return usersSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

// دالة لتحديث بيانات المستخدم
export const updateUserData = async (userId, updatedData) => {
  try {
    await updateDoc(doc(database, "users", userId), updatedData);
    return { success: true };
  } catch (error) {
    console.error('Error updating user:', error);
    return { success: false, error: error.message };
  }
};

// دالة لحذف المستخدم
export const deleteUserData = async (userId) => {
  try {
    await deleteDoc(doc(database, "users", userId));
    return { success: true };
  } catch (error) {
    console.error('Error deleting user:', error);
    return { success: false, error: error.message };
  }
};

// دالة لحذف الاختبار
export const deleteQuizData = async (quizId) => {
  try {
    await deleteDoc(doc(database, "quizzes", quizId));
    return { success: true };
  } catch (error) {
    console.error('Error deleting quiz:', error);
    return { success: false, error: error.message };
  }
};

// دالة لتحديث بيانات الاختبار
export const updateQuizData = async (quizId, updatedData) => {
  try {
    await updateDoc(doc(database, "quizzes", quizId), updatedData);
    return { success: true };
  } catch (error) {
    console.error('Error updating quiz:', error);
    if (error.code === 'permission-denied') {
      return { success: false, error: 'ليس لديك صلاحية لتحديث الاختبار' };
    }
    return { success: false, error: error.message };
  }
};